/** The notification source this module sends as. */
export const BACKUP_NOTIFICATIONS = "backup";
